// Cut decimal points without rounding them
const historyGameColor = (fix='history__game',crashPoint) => {
    const color = ['red','blue','green','purple','cyan','gold']
    // const fix='history__game';
    if(crashPoint <=1.05){
        return `${fix}_${color[0]}`
    }
    if(crashPoint>=1.06 && crashPoint<=1.96) {
        return `${fix}_${color[1]}`
    }
    if(crashPoint >=1.97 && crashPoint<=2.71){
        return `${fix}_${color[2]}`
    }
    if(crashPoint>=2.72 && crashPoint<=4.09) {
        return `${fix}_${color[3]}`
    }
    if(crashPoint>=4.09 && crashPoint<=9.73) {
        return `${fix}_${color[4]}`
    }
    if(crashPoint >=9.74 ){
        return `${fix}_${color[5]}`
    }
   
  };
  
  export default historyGameColor;